import { AppDetails } from '@core/app_details';

export function SocialNetworksPanel({
  inColumn,
  isReversed,
}: SocialNetworksPanelProps): JSX.Element {
  const onClick = (url: string) => {
    window.open(url);
  };

  return (
    <section className={`snp ${inColumn ? 'column' : ''}`}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => onClick(AppDetails.facebookUrl)}
      >
        <g clipPath="url(#clip0_1492_1103)">
          <path
            // eslint-disable-next-line max-len
            d="M12.8428 0.5C6.21541 0.5 0.842773 5.87264 0.842773 12.5C0.842773 18.1275 4.71733 22.8498 9.94405 24.1467V16.1672H7.46965V12.5H9.94405V10.9198C9.94405 6.83552 11.7925 4.9424 15.8025 4.9424C16.5628 4.9424 17.8746 5.09168 18.4113 5.24048V8.56448C18.1281 8.53472 17.6361 8.51984 17.025 8.51984C15.0575 8.51984 14.2972 9.26528 14.2972 11.203V12.5H18.2169L17.5434 16.1672H14.2972V24.4122C20.2391 23.6946 24.8433 18.6354 24.8433 12.5C24.8428 5.87264 19.4701 0.5 12.8428 0.5Z"
            fill={isReversed ? '#403B37' : '#F3F3F3'}
          />
        </g>
        <defs>
          <clipPath id="clip0_1492_1103">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.842773 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => onClick(AppDetails.instagramUrl)}
      >
        <g clipPath="url(#clip0_1492_1106)">
          <path
            // eslint-disable-next-line max-len
            d="M12.8428 2.66094C16.049 2.66094 16.4287 2.675 17.6896 2.73125C18.8615 2.78281 19.4943 2.97969 19.9162 3.14375C20.474 3.35938 20.8771 3.62188 21.2943 4.03906C21.7162 4.46094 21.974 4.85938 22.1896 5.41719C22.3537 5.83906 22.5506 6.47656 22.6021 7.64375C22.6584 8.90937 22.6725 9.28906 22.6725 12.4906C22.6725 15.6969 22.6584 16.0766 22.6021 17.3375C22.5506 18.5094 22.3537 19.1422 22.1896 19.5641C21.974 20.1219 21.7115 20.525 21.2943 20.9422C20.8725 21.3641 20.474 21.6219 19.9162 21.8375C19.4943 22.0016 18.8568 22.1984 17.6896 22.25C16.424 22.3062 16.0443 22.3203 12.8428 22.3203C9.63652 22.3203 9.25684 22.3062 7.9959 22.25C6.82402 22.1984 6.19121 22.0016 5.76934 21.8375C5.21152 21.6219 4.8084 21.3594 4.39121 20.9422C3.96934 20.5203 3.71152 20.1219 3.4959 19.5641C3.33184 19.1422 3.13496 18.5047 3.0834 17.3375C3.02715 16.0719 3.01309 15.6922 3.01309 12.4906C3.01309 9.28438 3.02715 8.90469 3.0834 7.64375C3.13496 6.47187 3.33184 5.83906 3.4959 5.41719C3.71152 4.85938 3.97402 4.45625 4.39121 4.03906C4.81309 3.61719 5.21152 3.35938 5.76934 3.14375C6.19121 2.97969 6.82871 2.78281 7.9959 2.73125C9.25684 2.675 9.63652 2.66094 12.8428 2.66094ZM12.8428 0.5C9.58496 0.5 9.17715 0.514062 7.89746 0.570312C6.62246 0.626563 5.7459 0.832812 4.98652 1.12812C4.19434 1.4375 3.52402 1.84531 2.8584 2.51562C2.18809 3.18125 1.78027 3.85156 1.4709 4.63906C1.17559 5.40313 0.969336 6.275 0.913086 7.55C0.856836 8.83437 0.842773 9.24219 0.842773 12.5C0.842773 15.7578 0.856836 16.1656 0.913086 17.4453C0.969336 18.7203 1.17559 19.5969 1.4709 20.3563C1.78027 21.1484 2.18809 21.8188 2.8584 22.4844C3.52402 23.15 4.19434 23.5625 4.98184 23.8672C5.7459 24.1625 6.61777 24.3687 7.89277 24.425C9.17246 24.4812 9.58027 24.4953 12.8381 24.4953C16.0959 24.4953 16.5037 24.4812 17.7834 24.425C19.0584 24.3687 19.935 24.1625 20.6943 23.8672C21.4818 23.5625 22.1521 23.15 22.8178 22.4844C23.4834 21.8188 23.8959 21.1484 24.2006 20.3609C24.4959 19.5969 24.7022 18.725 24.7584 17.45C24.8146 16.1703 24.8287 15.7625 24.8287 12.5047C24.8287 9.24688 24.8146 8.83906 24.7584 7.55938C24.7022 6.28438 24.4959 5.40781 24.2006 4.64844C23.9053 3.85156 23.4975 3.18125 22.8272 2.51562C22.1615 1.85 21.4912 1.4375 20.7037 1.13281C19.9396 0.8375 19.0678 0.63125 17.7928 0.575C16.5084 0.514063 16.1006 0.5 12.8428 0.5Z"
            fill={isReversed ? '#403B37' : '#F3F3F3'}
          />
          <path
            // eslint-disable-next-line max-len
            d="M12.8428 6.33594C9.43965 6.33594 6.67871 9.09687 6.67871 12.5C6.67871 15.9031 9.43965 18.6641 12.8428 18.6641C16.2459 18.6641 19.0068 15.9031 19.0068 12.5C19.0068 9.09687 16.2459 6.33594 12.8428 6.33594ZM12.8428 16.4984C10.635 16.4984 8.84434 14.7078 8.84434 12.5C8.84434 10.2922 10.635 8.50156 12.8428 8.50156C15.0506 8.50156 16.8412 10.2922 16.8412 12.5C16.8412 14.7078 15.0506 16.4984 12.8428 16.4984Z"
            fill={isReversed ? '#403B37' : '#F3F3F3'}
          />
          <path
            // eslint-disable-next-line max-len
            d="M20.6896 6.09238C20.6896 6.88926 20.0428 7.53145 19.2506 7.53145C18.4537 7.53145 17.8115 6.88457 17.8115 6.09238C17.8115 5.29551 18.4584 4.65332 19.2506 4.65332C20.0428 4.65332 20.6896 5.3002 20.6896 6.09238Z"
            fill={isReversed ? '#403B37' : '#F3F3F3'}
          />
        </g>
        <defs>
          <clipPath id="clip0_1492_1106">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.842773 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => onClick(AppDetails.linkedInUrl)}
      >
        <g clipPath="url(#clip0_1492_1112)">
          <path
            // eslint-disable-next-line max-len
            d="M23.0662 0.5H2.61465C1.63496 0.5 0.842773 1.27344 0.842773 2.22969V22.7656C0.842773 23.7219 1.63496 24.5 2.61465 24.5H23.0662C24.0459 24.5 24.8428 23.7219 24.8428 22.7703V2.22969C24.8428 1.27344 24.0459 0.5 23.0662 0.5ZM7.96309 20.9516H4.40059V9.49531H7.96309V20.9516ZM6.18184 7.93438C5.03809 7.93438 4.11465 7.01094 4.11465 5.87187C4.11465 4.73281 5.03809 3.80937 6.18184 3.80937C7.3209 3.80937 8.24434 4.73281 8.24434 5.87187C8.24434 7.00625 7.3209 7.93438 6.18184 7.93438ZM21.2943 20.9516H17.7365V15.3828C17.7365 14.0562 17.7131 12.3453 15.885 12.3453C14.0334 12.3453 13.7521 13.7937 13.7521 15.2891V20.9516H10.199V9.49531H13.6115V11.0609H13.6584C14.1318 10.1609 15.2943 9.20938 17.024 9.20938C20.6287 9.20938 21.2943 11.5813 21.2943 14.6656V20.9516Z"
            fill={isReversed ? '#403B37' : '#F3F3F3'}
          />
        </g>
        <defs>
          <clipPath id="clip0_1492_1112">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.842773 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => onClick(AppDetails.youtubeUrl)}
      >
        <g clipPath="url(#clip0_1492_1114)">
          <path
            // eslint-disable-next-line max-len
            d="M24.6037 7.6998C24.6037 7.6998 24.3693 6.04512 23.6475 5.31855C22.7334 4.3623 21.7115 4.35762 21.2428 4.30137C17.8865 4.05762 12.8475 4.05762 12.8475 4.05762H12.8381C12.8381 4.05762 7.79902 4.05762 4.44277 4.30137C3.97402 4.35762 2.95215 4.3623 2.03809 5.31855C1.31621 6.04512 1.08652 7.6998 1.08652 7.6998C1.08652 7.6998 0.842773 9.64512 0.842773 11.5857V13.4045C0.842773 15.3451 1.08184 17.2904 1.08184 17.2904C1.08184 17.2904 1.31621 18.9451 2.0334 19.6717C2.94746 20.6279 4.14746 20.5951 4.68184 20.6982C6.60371 20.8811 12.8428 20.9373 12.8428 20.9373C12.8428 20.9373 17.8865 20.9279 21.2428 20.6889C21.7115 20.6326 22.7334 20.6279 23.6475 19.6717C24.3693 18.9451 24.6037 17.2904 24.6037 17.2904C24.6037 17.2904 24.8428 15.3498 24.8428 13.4045V11.5857C24.8428 9.64512 24.6037 7.6998 24.6037 7.6998ZM10.3631 15.6123V8.86699L16.8459 12.2514L10.3631 15.6123Z"
            fill={isReversed ? '#403B37' : '#F3F3F3'}
          />
        </g>
        <defs>
          <clipPath id="clip0_1492_1114">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.842773 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </section>
  );
}
